"use strict";
import { useAppSelector } from "state/hooks";
import { selectIsAtomicBatchingSupportedByChainId } from "state/walletCapabilities/reducer";
import { useEvent } from "utilities/src/react/hooks";
export function useIsAtomicBatchingSupportedByChainIdCallback() {
  const isAtomicBatchingSupportedByChainId = useAppSelector(selectIsAtomicBatchingSupportedByChainId);
  return useEvent(isAtomicBatchingSupportedByChainId);
}
